import classNames from "classnames";
import React from "react";
import ReactTooltip from "react-tooltip";
import { GetSuggestionsFromB2FileInfos } from "source/app/presentation/Header/Tools/Sound/Music/CurrentSongInfo/GetSuggestions";
import { ShowPlaylistChangeText } from "source/app/presentation/Header/Tools/Sound/Music/CurrentSongInfo/ShowPlaylistChangeText";
import MusicMenu from "source/app/presentation/Header/Tools/Sound/Music/MusicMenu";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { Sounds } from "source/app/services/Sound/Sounds";
import { PlaylistLock } from "./PlaylistLock";
import Music from "source/app/services/Sound/Music/Music";
import { AddStatusMessage } from "source/app/presentation/MainPanel/StatusBar/StatusBar";
import { EStatusMessageType } from "source/app/presentation/MainPanel/StatusBar/StatusMessageType/StatusMessageType";

export function CurrentSongInfo({ musicMenu }: { musicMenu: MusicMenu }) {
    const { currentFileInfo, allFileInfos, selectedPlaylists } =
        musicMenu.state;

    if (!currentFileInfo) {
        return <div style={{ opacity: 0.5 }}>...</div>;
    }

    React.useEffect(() => {
        ReactTooltip.rebuild();

        ShowStatusMessage(
            selectedPlaylistName,
            albumName,
            fileNameWithoutExtension
        );
    }, [currentFileInfo]);

    const { playlistName, albumName, fileNameWithoutExtension } =
        currentFileInfo;

    const selectedPlaylistName =
        GetSelectedPlaylistName(selectedPlaylists, playlistName) ?? ``;

    return (
        <div>
            <ShowPlaylistChangeText
                currentPlaylistName={currentFileInfo.playlistName}
                selectedPlaylistName={selectedPlaylistName}
            />
            <FormSelect
                id="playlistName"
                onChange={(event) => {
                    Sounds.electronic_tones_melodic_positive.Play();

                    const extendedPlaylistValues =
                        Music.ExtendedPlaylistMap.GetValues(event.target.value);

                    const selectedPlaylists = extendedPlaylistValues
                        ? [...extendedPlaylistValues]
                        : [event.target.value];

                    musicMenu.setState({
                        selectedPlaylists,
                    });
                }}
                value={selectedPlaylistName}
                suggestions={GetSuggestionsFromB2FileInfos(
                    allFileInfos,
                    "playlistName",
                    Music.ExtendedPlaylistMap.GetKeys()
                )}
                classes={classNames(
                    StyleClassAuto({
                        opacity: 0.6,
                        display: `inline-block`,
                    }),
                    sharedStyleClass
                )}
                hideEmptyOption
                width="135px"
            />
            <PlaylistLock
                currentPlayListName={playlistName}
                isLocked={selectedPlaylists !== undefined}
            />
            <FormSelect
                id="albumName"
                onChange={() => {}}
                value={albumName}
                suggestions={GetSuggestionsFromB2FileInfos(
                    allFileInfos,
                    "albumName"
                )}
                classes={classNames(
                    StyleClassAuto({
                        opacity: 0.8,
                    }),
                    sharedStyleClass
                )}
                hideEmptyOption
            />
            <FormSelect
                id="fileNameWithoutExtension"
                onChange={() => {}}
                value={fileNameWithoutExtension}
                suggestions={GetSuggestionsFromB2FileInfos(
                    allFileInfos,
                    "fileNameWithoutExtension"
                )}
                classes={classNames(
                    StyleClassAuto({
                        opacity: 1,
                    }),
                    sharedStyleClass
                )}
                hideEmptyOption
            />
        </div>
    );
}

const sharedStyleClass = StyleClassAuto({
    width: `200px`,
    whiteSpace: `nowrap`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    textAlign: `center`,
});

function ShowStatusMessage(
    selectedPlaylistName: string,
    albumName: string,
    fileNameWithoutExtension: string
) {
    const statusMessage = `${selectedPlaylistName} > ${albumName} > ${fileNameWithoutExtension}`;
    AddStatusMessage(statusMessage, EStatusMessageType.info, 4000);
}

function GetSelectedPlaylistName(
    selectedPlaylists: string[] | undefined,
    currentPlaylistName: string
) {
    if (!selectedPlaylists) {
        return currentPlaylistName;
    }

    if (selectedPlaylists.length === 1) {
        return selectedPlaylists[0];
    }

    var extendedPlaylistName =
        Music.ExtendedPlaylistMap.GetKeyByValues(selectedPlaylists);

    return extendedPlaylistName;
}
